var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('gl-tree-view',{attrs:{"entries":_vm.itemCategories,"selected":_vm.categories},on:{"update:selected":function($event){return _vm.$emit('update:categories', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }